<template>
  <header>
    <div class="image-container">
      <div class="text-area">
        <h1 class="title">
          <span
            v-for="(text, index) in title"
            :key="index"
            class="text"
            >{{ text }}</span
          >
        </h1>
        <p class="date">
          {{ date }}
        </p>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
const props = defineProps<{
  imgSrc: string
  title: string[]
  date: string
}>()
const url = computed(() => `url(${props.imgSrc})`)
const emits = defineEmits([])
</script>

<style lang="scss" scoped>
.image-container {
  position: relative;
  background: linear-gradient(to bottom, rgb(0 0 0 / 50%), rgb(0 0 0 / 0%)), v-bind(url);
  background-size: cover;
  width: 100%;
  aspect-ratio: 1/1;
  .text-area {
    top: 30px;
    left: 16px;
    color: $base-white;
    .title {
      font-family: Pretendard;
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: 38px;
      margin-bottom: 10px;
      .text {
        display: block;
      }
    }
    .date {
      @include body7-regular;
    }
  }
}
</style>
